import { render, staticRenderFns } from "./vacancy-checkbox.vue?vue&type=template&id=21540cd4&scoped=true&lang=pug"
import script from "./vacancy-checkbox.vue?vue&type=script&lang=ts"
export * from "./vacancy-checkbox.vue?vue&type=script&lang=ts"
import style0 from "./vacancy-checkbox.vue?vue&type=style&index=0&id=21540cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21540cd4",
  null
  
)

export default component.exports